import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid } from '@mui/material';
import { useDevice } from 'components/DeviceContext.js';

const ModalAssistencia = ({ municipioData, onClose }) => {
    const [informacoesMunicipio, setInformacoesMunicipio] = useState(null);
    const {isMobile} = useDevice();

    useEffect(() => {
        const fetchInformacoesMunicipio = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/informacoes-municipio/ibge/${municipioData.ibge}`);
                if (!response.ok) {
                    throw new Error('Erro ao carregar informações do município');
                }
                const data = await response.json();
                setInformacoesMunicipio(data);
            } catch (error) {
                console.error(error);
            }
        };

        if (municipioData) {
            fetchInformacoesMunicipio();
        }
    }, [municipioData]);

    useEffect(() => {
        let timeoutId;

        const handleScroll = () => {
            clearTimeout(timeoutId); // Limpa o timeout anterior, se houver
            timeoutId = setTimeout(() => {
                onClose(); // Fecha o modal 3 segundos após o rolamento
            }, 30); // 3000 milissegundos = 3 segundos
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            clearTimeout(timeoutId); // Limpa o timeout ao desmontar o componente
            window.removeEventListener('scroll', handleScroll);
        };
    }, [onClose]);

    return (
        <Grid container style={{
            position: 'fixed',
            top: isMobile ? '90%' : '50%',
            left: isMobile ? '70%' : '80%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: ' 0 30px  10px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
            fontSize: '16px',
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '50%' : '14%'
        }}
        >
            <Grid style={{
                justifyContent: 'space-between',
                alignItems: 'center',
                display: 'flex'
            }}>
                <h3 style={{ fontSize: isMobile ? '14px' : '20px'}}>{municipioData.nome}</h3>
                <button style={{
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    fontSize: '20px'
                }}
                    onClick={onClose}>
                    <CloseIcon />
                </button>
            </Grid>
            {informacoesMunicipio ? (
                <>
                    <Grid style={{fontSize: isMobile ? '10px' : '15px'}}>
                        <p>População: {informacoesMunicipio.populacao}</p>
                        <p>Área: {informacoesMunicipio.area} km²</p>
                        <p>IDH: {informacoesMunicipio.idh} </p>
                    </Grid>
                </>
            ) : (
                <p>Carregando informações do município...</p>
            )}
        </Grid>
    );
};

export default ModalAssistencia;
